"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./~/@formatjs/ecma402-abstract/types/displaynames.js
// module id = 241
// module chunks = 0